import { Typography } from '@mui/material'
import React from 'react'
import { PropsTextFunction } from '../../../styles'

export const RegularText = (props) => {
  return (
    <Typography
        variant="body1"
        component="p"
        sx={ PropsTextFunction(props) }
    >
        { props?.text }
        { props?.component }
    </Typography>
  )
}
